module.exports = __webpack_public_path__ + "static/media/menu_del_info.abf79431.svg";